export default __webpack_public_path__ + "static/media/imgLight8.8b2703e1.png";